const ExpertJobsIndex = () => import('./index.vue')
const Applications = () => import('./_pages/applications.vue')
const Assignments = () => import('./_pages/assignments.vue')
import { ExpertGuard, CheckExpertGuard } from '@/common/guard'

export default [
    {
        path: '/expert/jobs',
        beforeEnter: CheckExpertGuard,
        component: ExpertJobsIndex,
        children: [
            {
                path: '',
                component: Applications
            },
            {
                path: 'assigned',
                component: Assignments
            }
        ]
    }
]